export default function defaultCallback() {
    return new Promise(function(resolve, reject) {
        resolve();
    });
}